module.exports = __webpack_public_path__ + "img/checkout_complete.1e6e1cfc.svg";